import NoData from '@rio-cloud/rio-uikit/NoData';
import Tag from '@rio-cloud/rio-uikit/Tag';
import TagList from '@rio-cloud/rio-uikit/TagList';
import { FormattedMessage } from 'react-intl';
import type { AssetTagListProps } from './types';

const ASSET_TAG_LIST_ICON_BY_TYPE = {
    tag: 'rioglyph-tag',
    group: 'rioglyph-group',
} as const;

const ASSET_TAG_LIST_DEVICE_ICON_BY_LABEL = {
    'RIO Box': 'rioglyph-tachograph',
    'Pocket Driver App': 'rioglyph-phone',
} as const;

const getAssetTagListIcon = (icon: AssetTagListProps['icon'], itemLabel: string) => {
    if (!icon) {
        return undefined;
    }

    if (icon === 'device') {
        return ASSET_TAG_LIST_DEVICE_ICON_BY_LABEL[itemLabel as keyof typeof ASSET_TAG_LIST_DEVICE_ICON_BY_LABEL];
    }

    return ASSET_TAG_LIST_ICON_BY_TYPE[icon];
};

export const AssetTagList = (props: AssetTagListProps) => {
    if (!props.items.length) {
        return <NoData text={<FormattedMessage id='intl-msg:common-message.noData' />} />;
    }

    return (
        <TagList className='margin-bottom-0'>
            {props.items.map(item => (
                <Tag key={item.id} size={'small'} icon={getAssetTagListIcon(props.icon, item.label)}>
                    {item.label}
                </Tag>
            ))}
        </TagList>
    );
};
